import React from 'react';

// Writes schema.org structured data into the page. "<" is escaped so text in
// the data can never close the script tag early.
const JsonLd = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
  />
);

export default JsonLd;
